import MessageIndex from "./js/MessageIndex.jsx";
import MessageForm from "./js/MessageForm.jsx";

const components = [
    MessageIndex, MessageForm,
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};